import type { RowTypeKey } from '@tryhackme/thm-ui-components';

import {
  type SetSubmissionsParamsFunction,
  type SubmissionRowType,
  type SubmissionsParams,
  SubmissionsSortFieldTypes,
  type SubmissionsTableType,
} from './submissions.types';

// Define a mapping between columnKey and the corresponding enum values
const sortEnumMapping: Partial<Record<RowTypeKey<SubmissionRowType>, SubmissionsSortFieldTypes>> = {
  roomTitle: SubmissionsSortFieldTypes.ROOM,
  makerUsername: SubmissionsSortFieldTypes.MAKER,
  roomType: SubmissionsSortFieldTypes.TYPE,
  testerUsername: SubmissionsSortFieldTypes.TESTER,
  requested: SubmissionsSortFieldTypes.REQUESTED,
  status: SubmissionsSortFieldTypes.STATUS,
  scheduled: SubmissionsSortFieldTypes.SCHEDULED,
};

export const sortData = (
  setActiveSortColumn: (value: SubmissionsTableType['activeSortColumn']) => void,
  setSubmissionsParams: SetSubmissionsParamsFunction,
  columnKey: RowTypeKey<SubmissionRowType>,
) => {
  // Get the mapped enum value
  const mappedValue = sortEnumMapping[columnKey];

  if (mappedValue) {
    setActiveSortColumn(columnKey);
    setSubmissionsParams((prevParams: SubmissionsParams) => {
      const newSortValue =
        prevParams.sort === mappedValue?.toString() ? `-${mappedValue?.toString()}` : mappedValue?.toString();

      return {
        ...prevParams,
        sort: newSortValue,
        page: 1,
      };
    });
  }
};
